<script setup lang="ts">
import type { THeroBannerIllustration } from './types'
import WidgetHeroBannerIllustrationCredits from './items/WidgetHeroBannerIllustrationCredits.vue'
import WidgetHeroBannerIllustrationIslamic from './items/WidgetHeroBannerIllustrationIslamic.vue'
import WidgetHeroBannerIllustrationDeposits from './items/WidgetHeroBannerIllustrationDeposits.vue'
import WidgetHeroBannerIllustrationCards from './items/WidgetHeroBannerIllustrationCards.vue'
import WidgetHeroBannerIllustrationBanks from './items/WidgetHeroBannerIllustrationBanks.vue'
import WidgetHeroBannerIllustrationMoneyTransfers from './items/WidgetHeroBannerIllustrationMoneyTransfers.vue'
import WidgetHeroBannerIllustrationInsurances from './items/WidgetHeroBannerIllustrationInsurances.vue'
import WidgetHeroBannerIllustrationCrypto from './items/WidgetHeroBannerIllustrationCrypto.vue'
import WidgetHeroBannerIllustrationDiscussions from './items/WidgetHeroBannerIllustrationDiscussions.vue'
import WidgetHeroBannerIllustrationEvents from './items/WidgetHeroBannerIllustrationEvents.vue'
import WidgetHeroBannerIllustrationVacancies from './items/WidgetHeroBannerIllustrationVacancies.vue'
import WidgetHeroBannerIllustrationQuiz from './items/WidgetHeroBannerIllustrationQuiz.vue'

const props = defineProps<{
  name: THeroBannerIllustration
}>()
</script>

<template>
  <WidgetHeroBannerIllustrationCredits v-if="props.name === 'credits'" />
  <WidgetHeroBannerIllustrationCredits v-else-if="props.name === 'mortgage'" variant="mortgage" />
  <WidgetHeroBannerIllustrationIslamic v-else-if="props.name === 'islamic'" />
  <WidgetHeroBannerIllustrationDeposits v-else-if="props.name === 'deposits'" />
  <WidgetHeroBannerIllustrationCards v-else-if="props.name === 'cards'" />
  <WidgetHeroBannerIllustrationBanks v-else-if="props.name === 'banks'" />
  <WidgetHeroBannerIllustrationMoneyTransfers v-else-if="props.name === 'money-transfers'" />
  <WidgetHeroBannerIllustrationInsurances v-else-if="props.name === 'insurances'" />
  <WidgetHeroBannerIllustrationCrypto v-else-if="props.name === 'crypto'" />
  <WidgetHeroBannerIllustrationDiscussions v-else-if="props.name === 'discussions'" />
  <WidgetHeroBannerIllustrationEvents v-else-if="props.name === 'events'" />
  <WidgetHeroBannerIllustrationVacancies v-else-if="props.name === 'vacancies'" />
  <WidgetHeroBannerIllustrationQuiz v-else-if="props.name === 'quiz'" />
</template>
